import { motion } from "framer-motion";

export const scrollToRegister = () => {
  const target = "#register";
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -40, duration: 1.3 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const openRegistration = () => {
  scrollToRegister();
  setTimeout(() => {
    const els = Array.from(
      document.querySelectorAll(
        "#wf_main_noCv6xz8Jn3wj9qcs2VFuCH3 a, #wf_main_noCv6xz8Jn3wj9qcs2VFuCH3 button"
      )
    );
    const cta = els.find(
      (el) => el.offsetParent !== null && /free workshop|get access|register|join/i.test(el.textContent)
    );
    if (cta) cta.click();
  }, 900);
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const StruckPrice = ({ children, className = "" }) => (
  <span className={`relative inline-block px-1 ${className}`}>
    {children}
    <span
      aria-hidden="true"
      className="absolute -left-1 -right-1 top-1/2 h-[3px] -translate-y-1/2 -rotate-3 rounded-full bg-red-300 pointer-events-none"
    />
  </span>
);

export const PartnerBadge = ({ className = "" }) => (
  <img
    src="/assets/amazon-partner-badge.png"
    alt="Amazon Selling Partner Appstore — Official Software Partner"
    data-testid="amazon-partner-badge"
    className={`h-11 w-auto drop-shadow-sm ${className}`}
    loading="lazy"
  />
);

export const Logo = ({ className = "", dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full px-4 py-2 ${
      dark ? "bg-white/10" : "bg-[#0b1528]"
    } ${className}`}
    data-testid="site-logo"
  >
    <img src="/assets/shield-icon.png" alt="Protego AI shield" className="h-5 w-5" />
    <span className="font-display font-bold text-[15px] tracking-tight text-white">
      Protego AI
    </span>
  </span>
);
